import React from "react";
import { TextField, Grid, Typography } from "@mui/material";
import Select from "react-select";
import { DatePicker } from "antd";
import { timeZoneOptions } from "../../../components/Data/MenuData";

const ChurchForm = ({
  handleChange,
  formData,
  setFormData,
  indianStatesOption,
  setCityOptions,
  indian_states,
  cityOptions,
  dsegmentOption,
  countriesOption,
  cityStateInput,
  setCityStateInput,
  subscriptionOption,
  dioceseOption,
}) => {
  // ... existing logic ...
  const inputWidth = "350px";
  const inputElementWidthStyle = `w-[${inputWidth}] p-3 h-10 font-sans text-sm font-light border border-gray-300 rounded-md outline-none`;
  const style = {
    control: (base) => ({
      ...base,
      border: "1px solid lightgray",
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  const dropDownChange = (selected, dropdown) => {
    setFormData({
      ...formData,
      [dropdown.name]: selected.value,
    });
  };

  const placeHolderText = (text) => (
    <span className="text-sm text-light">{text}</span>
  );

  return (
    <div className="grid grid-cols-2 gap-4 p-4 max-w-[800px] mx-auto">
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="church_code"
          type="text"
          required
          placeholder="Enter Church Code"
          autoComplete="new-password"
          disabled
          value={formData?.church_code && formData?.church_code}
        />
      </div>
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="church_name"
          type="text"
          required
          placeholder="Enter Church Name"
          autoComplete="new-password"
          onChange={handleChange}
          value={formData?.church_name && formData?.church_name}
        />
      </div>
      <div className="overflow-x-auto outline-none">
        <Select
          name="diocese_id"
          onChange={(selected, dropdown) => {
            setFormData({
              ...formData,
              diocese_id: selected.value,
              segment_id: selected?.dsegment,
            });
          }}
          options={dioceseOption}
          placeholder={placeHolderText("Select Diocese")}
          className={`w-[${inputWidth}] outline-none h-11`}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          styles={style}
          value={
            formData?.diocese_id &&
            dioceseOption?.find(
              (option) => option.value === formData.diocese_id
            )
          }
        />
      </div>
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="segment_id"
          type="text"
          required
          placeholder="Diocese Segment"
          disabled
          onChange={handleChange}
          value={
            formData?.segment_id &&
            dsegmentOption?.find(
              (option) => option.label === formData.segment_id
            )?.label
          }
        />
      </div>
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="email"
          type="text"
          required
          placeholder="Enter Email"
          autoComplete="new-password"
          onChange={handleChange}
        />
      </div>
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="phone_number"
          type="text"
          required
          placeholder="Enter Phone"
          autoComplete="new-password"
          onChange={handleChange}
        />
      </div>
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="mobile_number"
          type="text"
          required
          placeholder="Enter Mobile Number"
          autoComplete="new-password"
          onChange={handleChange}
        />
      </div>
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="website"
          type="text"
          required
          placeholder="Enter Website https://"
          autoComplete="new-password"
          onChange={handleChange}
        />
      </div>
      <div className="overflow-x-auto">
        <Select
          name="country"
          onChange={(selected, dropdown) => {
            if (selected.value === "IN") {
              setCityStateInput(true);
              setFormData({
                ...formData,
                country: selected.value,
                state: null,
                city: null,
              });
            } else {
              setCityStateInput(false);
              setFormData({
                ...formData,
                country: selected.value,
                state: null,
                city: null,
              });
            }
          }}
          options={countriesOption}
          className={`w-[${inputWidth}] outline-none h-11`}
          placeholder={placeHolderText("Select Country")}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          value={
            formData?.country &&
            countriesOption?.find((c) => c.value === formData?.country)
          }
        />
      </div>
      {cityStateInput ? (
        <div className="overflow-x-auto outline-none">
          <Select
            name="state"
            onChange={(selected, dropdown) => {
              setFormData({
                ...formData,
                [dropdown.name]: selected.value,
                city: null,
              });
              setCityOptions(
                indian_states[selected.value].map((d, i) => {
                  return { value: d, label: d };
                })
              );
            }}
            placeholder={placeHolderText("Select State")}
            options={indianStatesOption}
            classNamePrefix="my-select"
            className="h-10 outline-none"
            menuPortalTarget={document.body}
            menuPosition={"fixed"}
            styles={style}
          />
        </div>
      ) : (
        <div className="overflow-x-auto">
          <input
            className={inputElementWidthStyle}
            name="state"
            type="text"
            required
            placeholder="Enter State"
            autoComplete="new-password"
            onChange={handleChange}
            value={formData?.state && formData?.state}
          />
        </div>
      )}
      {cityStateInput ? (
        <div className="overflow-x-auto">
          <Select
            name="city"
            onChange={dropDownChange}
            options={cityOptions}
            className="h-10 outline-none"
            placeholder={placeHolderText("Select City")}
            menuPortalTarget={document.body}
            menuPosition={"fixed"}
            value={
              formData.city && { value: formData.city, label: formData.city }
            }
            styles={style}
          />
        </div>
      ) : (
        <div className="overflow-x-auto">
          <input
            className={inputElementWidthStyle}
            name="city"
            type="text"
            required
            placeholder="Enter City"
            autoComplete="new-password"
            onChange={handleChange}
            value={formData?.city && formData?.city}
          />
        </div>
      )}
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="address"
          type="text"
          required
          placeholder="Enter Address"
          autoComplete="new-password"
          onChange={handleChange}
        />
      </div>
      <div className="overflow-x-auto">
        <input
          className={inputElementWidthStyle}
          name="zipcode"
          type="number"
          placeholder="Enter Zip code"
          autoComplete="new-password"
          onChange={handleChange}
          value={formData?.zipcode && formData?.zipcode}
        />
      </div>
      <div className="overflow-x-auto outline-none">
        <Select
          name="time_zone"
          onChange={(selected, dropdown) => {
            setFormData({
              ...formData,
              time_zone: selected.value,
            });
          }}
          options={timeZoneOptions}
          placeholder={placeHolderText("Select Time Zone")}
          className={`w-[${inputWidth}] outline-none h-11`}
          styles={style}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          value={
            formData?.time_zone && {
              value: formData?.time_zone,
              label: timeZoneOptions.find(
                (tz) => tz.value === formData?.time_zone
              )?.label,
            }
          }
        />
      </div>
      {/* {JSON.stringify(formData)} */}
    </div>
  );
};

export default ChurchForm;
